import React, { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import AuthGuard from '../components/AuthGuard';
import CampaignAnalytics from '../screens/campaign-reports';
import UserReports from '../screens/user-reports';
import Blog from '../screens/blogs';

const LoginPage = lazy(() => import('../screens/login/Login'));
const RegisterPage = lazy(() => import('../screens/register/Register'));
const HomePage = lazy(() => import('../screens/HomePage'));
const HeroBanner = lazy(() => import('../screens/hero-banner'));
const EngagementCard = lazy(() => import('../screens/engagement-card'));
const Faq = lazy(() => import('../screens/faq'));
const LegalText = lazy(() => import('../screens/legal-text'));
const StaticTexts = lazy(() => import('../screens/static-texts'));
const ConsumerCardPage = lazy(() => import('../screens/consumer-card'));
const ConsumerCardDetail = lazy(() => import('../screens/consumer-card-detail/detail'));
const CampaignBlog = lazy(() => import('../screens/campaign-blogs'));
const Onboarding = lazy(() => import('../screens/onboarding'));
const PushNotification = lazy(() => import('../screens/push-notification'));
const Branches = lazy(() => import('../screens/branches'));
const InAppNotification = lazy(() => import('../screens/in-app-notification'));
const UserManagement = lazy(() => import('../screens/user-management'));
const DigitalMenu = lazy(() => import('../screens/digital-menu'));
const CategoryDefinitions = lazy(() => import('../screens/category-definitions'));
const ExternalLink = lazy(() => import('../screens/external-link'));
const ManualMenu = lazy(() => import('../screens/manual-menu'));
const AllCampaigns = lazy(() => import('../screens/all-campaigns'));

// Loading fallback component
const LoadingFallback = () => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px' }}>
    <div>Loading...</div>
  </div>
);

const AppRoutes: React.FC = () => {
  return (
    <Suspense fallback={<LoadingFallback />}>
      <Routes>
        <Route
          path="/login"
          element={
            <AuthGuard requireAuth={false}>
              <LoginPage />
            </AuthGuard>
          }
        />
        //
        <Route
          path="/activate/:hash"
          element={
            <AuthGuard requireAuth={false}>
              <RegisterPage />
            </AuthGuard>
          }
        />
        <Route
          path="/*"
          element={
            <AuthGuard requireAuth={true}>
              <MainLayout>
                <Suspense fallback={<LoadingFallback />}>
                  <Routes>
                    <Route
                      path="/"
                      element={<UserReports />}
                    />
                    <Route
                      path="/hero-banner"
                      element={<HeroBanner />}
                    />
                    <Route
                      path="/engagement-card"
                      element={<EngagementCard />}
                    />
                    <Route
                      path="/faq"
                      element={<Faq />}
                    />
                    <Route
                      path="/legal-text"
                      element={<LegalText />}
                    />
                    <Route
                      path="/static-texts"
                      element={<StaticTexts />}
                    />
                    <Route
                      path="/campaign-analytics/:campaignId"
                      element={<CampaignAnalytics />}
                    />
                    <Route
                      path="/user-reports"
                      element={<UserReports />}
                    />
                    <Route
                      path="/all-campaigns"
                      element={<AllCampaigns />}
                    />
                    <Route
                      path="/home"
                      element={<HomePage />}
                    />
                    <Route
                      path="/consumer-card"
                      element={<ConsumerCardPage />}
                    />
                    <Route
                      path="/consumer-card/:consumerId"
                      element={<ConsumerCardDetail />}
                    />
                    <Route
                      path="/campaigns"
                      element={<CampaignBlog />}
                    />
                    <Route
                      path="/blogs"
                      element={<Blog />}
                    />
                    <Route
                      path="/onboarding"
                      element={<Onboarding />}
                    />
                    <Route
                      path="/push-notification"
                      element={<PushNotification />}
                    />
                    <Route
                      path="/branches"
                      element={<Branches />}
                    />
                    <Route
                      path="/in-app-notification"
                      element={<InAppNotification />}
                    />
                    <Route
                      path="/user-management"
                      element={<UserManagement />}
                    />
                    <Route
                      path="/digital-menu"
                      element={<DigitalMenu />}
                    />
                    <Route
                      path="/category-definitions"
                      element={<CategoryDefinitions />}
                    />
                    <Route
                      path="/external-link"
                      element={<ExternalLink />}
                    />
                    <Route
                      path="/manual-menu"
                      element={<ManualMenu />}
                    />
                  </Routes>
                </Suspense>
              </MainLayout>
            </AuthGuard>
          }
        />
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;
